import React from 'react';
import { useHistory } from 'react-router-dom';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import DisponibilidadeHeader from './DisponibilidadeHeader';
import FilterPanel from '@spark/ui-components/components/FilterPanel';
import DisponibilidadeTable from './DisponibilidadeTable';
import { filterConfig } from '../config/filterConfig';
import { useDisponibilidadeListagem } from '../hooks/useDisponibilidadeListagem';

const DisponibilidadeCard = () => {
  const history = useHistory();
  const {
    data,
    loading,
    filterLoading,
    totalRegistros,
    paginaAtual,
    quantidadePorPagina,
    setPaginaAtual,
    setQuantidadePorPagina,
    handleFilterApply
  } = useDisponibilidadeListagem();

  const handleRowClick = row => {
    if (!row || row.id == null) return;
    history.push(`/pages/programacao/detalhesdisponibilidade/${row.id}`);
  };


  const handleAdicionar = () => {
    history.push('/pages/programacao/criardisponibilidade');
  };

  return <Card>
    <CardBody>
      <DisponibilidadeHeader totalRegistros={totalRegistros} onAdicionar={handleAdicionar} />

      <FilterPanel filters={filterConfig} onApply={handleFilterApply} title="Filtros de Disponibilidade" loading={filterLoading} defaultCollapsed={true} />

      <DisponibilidadeTable data={data} loading={loading} totalRegistros={totalRegistros} paginaAtual={paginaAtual} quantidadePorPagina={quantidadePorPagina} setPaginaAtual={setPaginaAtual} setQuantidadePorPagina={setQuantidadePorPagina} onRowClick={handleRowClick} />
    </CardBody>
  </Card>;
};

export default DisponibilidadeCard;
